import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import ScratchTicketView from "./scratch_ticket_view";

const { ccclass, property } = cc._decorator;


@ccclass
@moduleInit("ScratchTicket")
export default class ScratchTicket extends ModuleBase<ScratchTicketView, null> {


    constructor() {
        super();
        
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/scratch_ticket/scratch_ticket";
        this.viewType = ScratchTicketView;
        this.modelType = null;
        this.needAnim = true
        this.needViewMask = true
        this.hideTriggerDestroy = true
    }
}